import api from '@/utils/api';

/**
 * Export company prices
 * @param {string} companyId Company id
 * @param {object} exportData - The export (price_type) data
 * @returns {Promise}
 */
const exportCompanyPriceApi = (companyId, exportData) =>
  api.post(`/company/${companyId}/price/export`, exportData);

export default exportCompanyPriceApi;
